export function isFilledValue(value) {
  return value !== null && value !== undefined && value !== ''
}
